var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatbubbleTyping = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M9.891 1.243a10.96 10.96 0 0 1 6.864.884 10.959 10.959 0 1 1-9.33 19.83l-5.463.985a.79.79 0 0 1-.876-1.05l1.565-4.169a10.96 10.96 0 0 1 7.24-16.48m6.042 2.586a9.07 9.07 0 0 0-11.67 12.907l.482.787-1.207 3.215 4.146-.747.546.257a9.069 9.069 0 0 0 7.72-16.411l-.008-.004zm-8.665 6.594a1.575 1.575 0 1 1 .002 3.15 1.575 1.575 0 0 1-.002-3.15m4.728 0a1.575 1.575 0 1 1 .001 3.15 1.575 1.575 0 0 1-.001-3.15m4.727 0a1.576 1.576 0 1 1 .002 3.15 1.576 1.576 0 0 1-.002-3.15"
})));
export default SvgChatbubbleTyping;